export const heroArticles = [
  {
    id: 1,
    title: '深度揭秘：某知名互联网企业数据泄露内幕，数千万用户信息被非法交易',
    slug: 'tech-data-leak-2026',
    category: '内幕揭秘',
    categorySlug: 'insider-reveal',
    excerpt: '经过长达三个月的深入调查，我们发现某头部互联网公司存在严重的数据安全漏洞，导致超过3000万用户的个人信息在黑市上被公开叫卖。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20investigative%20scene%20with%20silhouetted%20figure%20holding%20documents%20against%20dim%20urban%20night%20background%2C%20moody%20cinematic%20lighting%20with%20deep%20shadows%20and%20warm%20amber%20accents%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20low%20key%20photography%2C%20corporate%20intrigue%20theme&width=1600&height=900&seq=hero-main-01&orientation=landscape',
    date: '2026-06-28',
    views: 128500,
    hot: true,
  },
  {
    id: 2,
    title: '娱乐圈惊天丑闻：顶流艺人背后资本运作链曝光，涉及金额超十亿',
    slug: 'entertainment-capital-scandal',
    category: '丑闻曝光',
    categorySlug: 'scandal-expose',
    excerpt: '一份内部财务文档揭示了某顶流艺人背后的复杂资本运作网络，涉及多家空壳公司、洗钱嫌疑以及偷税漏税行为。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20backstage%20scene%20with%20spotlight%20and%20long%20shadows%20on%20empty%20stage%2C%20dramatic%20noir%20lighting%2C%20theatrical%20atmosphere%20with%20crimson%20and%20charcoal%20tones%2C%20cinematic%20composition%2C%20entertainment%20industry%20expose%20theme&width=1600&height=900&seq=hero-sub-01&orientation=landscape',
    date: '2026-06-27',
    views: 96200,
    hot: true,
  },
  {
    id: 3,
    title: '食品安全黑幕：多家知名连锁餐饮使用过期变质食材，后厨画面触目惊心',
    slug: 'food-safety-scandal',
    category: '独家黑料',
    categorySlug: 'exclusive',
    excerpt: '暗访记者潜入多家网红连锁餐厅后厨，拍下了令人震惊的画面——发霉的原料、重复使用的回收油、蟑螂横行的操作间。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20gritty%20industrial%20kitchen%20scene%20with%20dim%20overhead%20lighting%2C%20stainless%20steel%20surfaces%20with%20deep%20shadows%2C%20moody%20atmospheric%20tone%2C%20investigative%20documentary%20style%2C%20warm%20amber%20highlights%20on%20dark%20charcoal%20background&width=1600&height=900&seq=hero-sub-02&orientation=landscape',
    date: '2026-06-26',
    views: 154300,
    hot: true,
  },
];

export const categories = [
  {
    slug: 'insider-reveal',
    name: '内幕揭秘',
    icon: 'ri-eye-line',
    description: '深度调查，还原事件真相',
    count: 128,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20background%20with%20single%20beam%20of%20warm%20amber%20light%20illuminating%20center%2C%20minimalist%20composition%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20deep%20charcoal%20tones%20with%20subtle%20crimson%20accents&width=800&height=600&seq=cat-insider-01&orientation=landscape',
  },
  {
    slug: 'scandal-expose',
    name: '丑闻曝光',
    icon: 'ri-alert-line',
    description: '第一时间揭露惊天丑闻',
    count: 96,
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20scene%20with%20cracked%20surface%20texture%2C%20warm%20crimson%20light%20seeping%20through%20fractures%2C%20moody%20atmospheric%20tone%2C%20cinematic%20composition%2C%20deep%20charcoal%20background%20with%20subtle%20illumination&width=800&height=600&seq=cat-scandal-01&orientation=landscape',
  },
  {
    slug: 'exclusive',
    name: '独家黑料',
    icon: 'ri-key-2-line',
    description: '51黑料网独家重磅爆料',
    count: 74,
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20composition%20with%20golden%20key%20element%20floating%20in%20shadow%2C%20warm%20amber%20spotlight%20effect%2C%20cinematic%20noir%20style%2C%20deep%20charcoal%20background%20with%20dramatic%20contrast%2C%20minimalist%20editorial%20photography&width=800&height=600&seq=cat-exclusive-01&orientation=landscape',
  },
  {
    slug: 'finance',
    name: '财经黑幕',
    icon: 'ri-money-dollar-circle-line',
    description: '资本游戏背后的惊人真相',
    count: 63,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20financial%20theme%20with%20scattered%20documents%20in%20dim%20light%2C%20warm%20crimson%20and%20charcoal%20tones%2C%20moody%20cinematic%20atmosphere%2C%20corporate%20intrigue%20style%2C%20deep%20shadows%20with%20subtle%20golden%20accents&width=800&height=600&seq=cat-finance-01&orientation=landscape',
  },
  {
    slug: 'politics',
    name: '政商关系',
    icon: 'ri-building-line',
    description: '权力与利益的灰色地带',
    count: 51,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20architectural%20scene%20with%20government%20building%20silhouette%20against%20moody%20sky%2C%20dramatic%20low%20key%20lighting%2C%20warm%20amber%20window%20glow%2C%20cinematic%20noir%20composition%2C%20deep%20charcoal%20tones&width=800&height=600&seq=cat-politics-01&orientation=landscape',
  },
  {
    slug: 'internet',
    name: '互联网圈',
    icon: 'ri-global-line',
    description: '科技巨头不可告人的秘密',
    count: 89,
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20network%20theme%20with%20glowing%20data%20nodes%20in%20amber%20light%2C%20mysterious%20cyber%20atmosphere%2C%20deep%20charcoal%20background%20with%20subtle%20crimson%20pulse%2C%20cinematic%20editorial%20style&width=800&height=600&seq=cat-internet-01&orientation=landscape',
  },
];

export const dailyUpdates = [
  {
    id: 4,
    title: '某省会城市住建局原局长被查，涉案金额或高达2亿',
    slug: 'govt-official-probe',
    category: '独家黑料',
    categorySlug: 'exclusive',
    image: 'https://readdy.ai/api/search-image?query=Dark%20government%20building%20silhouette%20with%20single%20illuminated%20window%2C%20moody%20night%20scene%2C%20cinematic%20noir%20lighting%2C%20investigative%20journalism%20theme%2C%20deep%20charcoal%20tones%20with%20warm%20amber%20accents&width=800&height=600&seq=daily-01&orientation=landscape',
    date: '2026-06-29',
    views: 89200,
  },
  {
    id: 5,
    title: '知名电商平台虚假促销内幕：先涨价再打折的套路全揭秘',
    slug: 'ecommerce-fake-promo',
    category: '内幕揭秘',
    categorySlug: 'insider-reveal',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20ecommerce%20theme%20with%20shopping%20cart%20silhouette%20in%20shadow%2C%20dramatic%20low%20key%20lighting%2C%20crimson%20price%20tag%20glow%2C%20cinematic%20editorial%20style%2C%20deep%20charcoal%20background&width=800&height=600&seq=daily-02&orientation=landscape',
    date: '2026-06-29',
    views: 67300,
  },
  {
    id: 6,
    title: '教育行业乱象：多家培训机构涉嫌虚假宣传，学员退款无门',
    slug: 'edtech-training-scandal',
    category: '丑闻曝光',
    categorySlug: 'scandal-expose',
    image: 'https://readdy.ai/api/search-image?query=Dark%20empty%20classroom%20with%20single%20desk%20under%20spotlight%2C%20moody%20atmospheric%20lighting%2C%20cinematic%20noir%20composition%2C%20investigative%20theme%2C%20deep%20charcoal%20and%20amber%20tones&width=800&height=600&seq=daily-03&orientation=landscape',
    date: '2026-06-29',
    views: 54100,
  },
  {
    id: 7,
    title: '医疗美容行业惊天陷阱：非法注射物致数百人毁容',
    slug: 'beauty-treatment-scandal',
    category: '独家黑料',
    categorySlug: 'exclusive',
    image: 'https://readdy.ai/api/search-image?query=Dark%20medical%20theme%20abstract%20with%20silhouetted%20medical%20tools%2C%20dramatic%20low%20key%20lighting%2C%20crimson%20warning%20tone%2C%20cinematic%20atmosphere%2C%20deep%20charcoal%20background&width=800&height=600&seq=daily-04&orientation=landscape',
    date: '2026-06-28',
    views: 120600,
  },
  {
    id: 8,
    title: '汽车行业减配黑幕：同一车型国内外配置差异触目惊心',
    slug: 'auto-spec-scandal',
    category: '内幕揭秘',
    categorySlug: 'insider-reveal',
    image: 'https://readdy.ai/api/search-image?query=Dark%20automotive%20theme%20with%20car%20silhouette%20in%20shadow%2C%20dramatic%20garage%20lighting%2C%20cinematic%20noir%20style%2C%20investigative%20atmosphere%2C%20deep%20charcoal%20and%20amber%20tones&width=800&height=600&seq=daily-05&orientation=landscape',
    date: '2026-06-28',
    views: 78500,
  },
];

export const hotArticles = [
  {
    id: 9,
    title: '某知名投资机构合伙人被曝涉嫌内幕交易，证监会已介入调查',
    slug: 'investment-insider-trading',
    category: '财经黑幕',
    categorySlug: 'finance',
    excerpt: '知情人士透露，该合伙人在多起重大并购案公布前进行异常交易，获利超过5000万元。目前证监会已正式立案。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20abstract%20with%20scattered%20documents%20in%20dramatic%20low%20light%2C%20moody%20cinematic%20noir%20lighting%2C%20financial%20investigation%20theme%2C%20deep%20charcoal%20tones%20with%20amber%20accents&width=800&height=600&seq=hot-01&orientation=landscape',
    date: '2026-06-28',
    views: 198300,
    hot: true,
  },
  {
    id: 10,
    title: '房地产行业大洗牌：前20强房企中已有5家资金链断裂',
    slug: 'real-estate-crisis',
    category: '内幕揭秘',
    categorySlug: 'insider-reveal',
    excerpt: '据内部人士提供的银行流水和财务报表显示，多家头部房企已无法偿还到期债务，涉及金额超过千亿规模。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20construction%20site%20silhouette%20with%20crane%20against%20moody%20sky%2C%20dramatic%20cinematic%20lighting%2C%20real%20estate%20theme%2C%20deep%20charcoal%20tones%20with%20subtle%20crimson%20highlights&width=800&height=600&seq=hot-02&orientation=landscape',
    date: '2026-06-27',
    views: 167400,
    hot: true,
  },
  {
    id: 11,
    title: '直播带货数据造假产业链：刷单、刷量、刷评论一条龙服务',
    slug: 'live-stream-fraud',
    category: '丑闻曝光',
    categorySlug: 'scandal-expose',
    excerpt: '暗访记者卧底某刷单工作室，揭秘直播带货行业令人震惊的数据造假产业，知名主播也不能幸免。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20phone%20screens%20glowing%20in%20amber%20light%2C%20moody%20cinematic%20atmosphere%2C%20social%20media%20theme%2C%20deep%20charcoal%20tones%2C%20investigative%20journalism%20style&width=800&height=600&seq=hot-03&orientation=landscape',
    date: '2026-06-26',
    views: 143200,
    hot: true,
  },
  {
    id: 12,
    title: '保险行业理赔黑幕：故意拖延、无理拒赔的套路全面曝光',
    slug: 'insurance-claim-scandal',
    category: '独家黑料',
    categorySlug: 'exclusive',
    excerpt: '数百份内部培训资料显示，多家保险公司存在系统性的理赔拖延策略，专门针对普通消费者设置障碍。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20insurance%20theme%20with%20torn%20documents%20in%20dramatic%20lighting%2C%20moody%20cinematic%20composition%2C%20deep%20charcoal%20tones%20with%20crimson%20and%20amber%20accents&width=800&height=600&seq=hot-04&orientation=landscape',
    date: '2026-06-25',
    views: 95600,
    hot: false,
  },
  {
    id: 13,
    title: '某省高考舞弊案细节披露：监考老师与考生内外勾结',
    slug: 'exam-cheating-scandal',
    category: '丑闻曝光',
    categorySlug: 'scandal-expose',
    excerpt: '2026年高考期间，某省多个考点被曝存在有组织的舞弊行为，涉及监考人员、教育系统内部人员协同作案。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20empty%20examination%20hall%20with%20single%20desk%20illuminated%2C%20dramatic%20noir%20lighting%2C%20cinematic%20atmosphere%2C%20deep%20charcoal%20tones%20with%20subtle%20amber%20highlights&width=800&height=600&seq=hot-05&orientation=landscape',
    date: '2026-06-24',
    views: 211500,
    hot: true,
  },
  {
    id: 14,
    title: '某共享经济独角兽企业财务造假，估值虚高十倍以上',
    slug: 'unicorn-finance-fraud',
    category: '财经黑幕',
    categorySlug: 'finance',
    excerpt: '一份从内部流出的审计报告草稿显示，该独角兽企业的实际营收仅为其对外公布数据的十分之一，大量订单为虚构。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20tech%20office%20with%20glowing%20screens%20in%20dim%20amber%20light%2C%20moody%20cinematic%20composition%2C%20startup%20investigation%20theme%2C%20deep%20charcoal%20tones&width=800&height=600&seq=hot-06&orientation=landscape',
    date: '2026-06-23',
    views: 178900,
    hot: true,
  },
];

export const stats = [
  { value: '1,286', label: '累计曝光' },
  { value: '8.6M', label: '月活跃用户' },
  { value: '98.7%', label: '信息准确率' },
  { value: '24h', label: '响应速度' },
];

export const testimonials = [
  {
    id: 1,
    name: '李先生',
    role: '资深媒体人',
    content: '51黑料网的报道深度和速度在业内都是有口皆碑的。多次独家爆料都走在了传统媒体前面，是我们获取线索的重要渠道。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle%20aged%20Chinese%20man%20in%20dark%20suit%2C%20clean%20studio%20lighting%2C%20simple%20dark%20background%2C%20editorial%20quality&width=200&height=200&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    name: '王女士',
    role: '消费者权益保护者',
    content: '因为51黑料网曝光了我们小区的物业黑幕，才引起了有关部门的重视，问题最终得到了解决。感谢这个平台为普通人发声。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20woman%20in%20her%20thirties%2C%20clean%20studio%20lighting%2C%20simple%20dark%20background%2C%20editorial%20quality&width=200&height=200&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    name: '张总',
    role: '企业合规顾问',
    content: '我每天都会看51黑料网的更新，了解行业风险动态。很多企业合规问题都是从这里先看到预警，然后才开始内部排查的。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20businessman%20with%20glasses%2C%20clean%20studio%20lighting%2C%20simple%20dark%20background%2C%20editorial%20quality&width=200&height=200&seq=avatar-03&orientation=squarish',
  },
];
